'use strict'

import {bootstrap} from '../bootstrap/bootstrap'

export default class ComponentLoader {
  constructor() {
    this.loaderElement = undefined
    this.fadeOutSpeed = 600
  }

  hideLoader(cb) {
    this.loaderElement.classList.add('component-loader--hide')
    window.setTimeout(() => {
      this.loaderElement.style.display = 'none'
      cb()
    }, this.fadeOutSpeed)
  }

  selectLoader(el) {
    bootstrap(el, el => {
      this.loaderElement = el
    })
  }
}
